import React from "react"
import { colorForSource, initialsForSource } from "../../utils/parsers/source"

const SourceBadge = ({ sourceName, size = "sm" }) => {
  const color = colorForSource(sourceName)
  const initials = initialsForSource(sourceName)
  const dims = size === "sm" ? "w-5 h-5 text-[9px]" : "w-6 h-6 text-[10px]"

  return (
    <span className="inline-flex items-center gap-1.5 min-w-0">
      <span
        className={`inline-flex items-center justify-center rounded-full font-semibold text-white shrink-0 ${dims}`}
        style={{ backgroundColor: color }}
      >
        {initials}
      </span>
      <span className="text-xs text-[#5A6779] truncate">{sourceName}</span>
    </span>
  )
}

export default SourceBadge
